import { IPagination } from './pagination.interface';
import { IFilter } from './filter.interface';
import { ISorting } from './sorting.interface';
import { Observable } from 'rxjs';
import { ISortSection } from './sort-section.interface';
import { IFilterSection } from './filter-section.interface';

export enum KorviuListItemTypes {
  CATEGORY = 'category',
  PRODUCT = 'product',
  TRANSACTION = 'transaction',
  GANARBOL = 'ganarbol',
  REFERRAL = 'referral',
  REFERRAL_GANASOCIOS = 'referral_ganasocios',
  GANAMIGOSNETWORK = 'ganamigosNetwork',
  BRAND = 'brand',
  MY_SPECIAL_FOREST = 'my_special_forest',
  SPECIAL_PAYMENTS = 'special_payments',
  TOTAL_CONTRIBUTION = 'total_contribution',
  MY_FOREST = 'my_forest',
  MY_FOREST_SPECIAL = 'my_forest_special',
  RECENT_ACTIVITY = 'recent_activity',
  PRODUCT_LIST = 'product_list'
}

export interface IKorviuListHighlightedItem {
  field: 'id' | 'purchaseId' | 'earnedMonth';
  value: number | string;
}

export interface IKorviuListConfig {
  getFn: (pagination?: IPagination, filters?: IFilter[], sorting?: ISorting) => Observable<any>;
  sortSections: ISortSection[];
  filterSections: IFilterSection[];
  doNotSortFilterSections?: boolean;
  filterSectionsGetFn?: () => Observable<IFilterSection[]>;
  detailsFn?: (id: any) => void;
  createLabel?: string;
  createLabelLocalizable?: string;
  createFn?: () => void;
  itemType?: KorviuListItemTypes;
  totalLocalizableName?: string;
  totalLocalizableNameFn?: () => string;
  toggleFavoriteFn?: (id: number) => void;
  redeemableChangeFn?: (country: string) => void;
  hideFilterSection?: boolean;
  hideSearch?: boolean;
  enableBulkRemoval?: boolean;
  customFunctions?: Map<string, (data?: any) => {}>;
  pagination?: IPagination;
  scrollPagination?: boolean;
  /**  */
  search?: IFilter;
  filters?: IFilter[];
  sorting?: ISorting;
  highlightedItem?: IKorviuListHighlightedItem;
}
